module.exports = __webpack_public_path__ + "static/media/FormatEditor.2fd6a3f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/FormatEditor.mp4
// module id = qK8B
// module chunks = 1